export default {
	common: {
		close: "關閉",
		save: "確認保存",
		edit: "編輯",
		confirm: "確認",
		cancel: "取消",
		back: "返回",
		loadMore: "加載更多",
		noData: "暫無數據",
		viewDetails: "查看詳情",
		contactKefu: "聯繫客服",
		copySuccess: "複製成功",
		personalCenter: "個人中心",
		yes: "是",
		no: "否",
	},
	default: {
		title: "我的檔案",
		addFile: "添加檔案",
		privacyTip: "你的資料將受到嚴格保護，僅用於提供更精準的服務",
	},
	baziFile: {
		empty: "暫無檔案",
		firstFileTitle: "請添加你的第一個檔案吧~",
		name: "姓名",
		namePlaceholder: "請輸入姓名",
		gender: "性別",
		birthDate: "出生日期",
		birthDatePlaceholder: "請選擇你的出生日期",
		birthArea: "出生地區",
		birthAreaPlaceholder: "請選擇你的出生地區",
		livingArea: "居住地區",
		livingAreaPlaceholder: "請選擇你的居住地區",
		relation: "請選擇與你的關係",
		relationMine: "我的",
		relationFamily: "親人",
		relationFriend: "朋友",
		male: "男性",
		female: "女性",
		editTitle: "資料編輯",
		solar: "公歷",
		lunar: "農曆",
		nameRequired: "請輸入姓名",
		genderRequired: "請選擇性別",
		birthDateRequired: "請選擇你的出生日期",
		futureDateError: "不能選擇大於當前的時間",
		relationRequired: "請選擇與你的關係",
		deleteFile: "刪除檔案",
		deleteConfirm: "確認刪除該檔案嗎？",
		confirmDelete: "確認刪除",
		deleteUnsupported: "暫不支持刪除檔案",
		inUse: "使用中",
	},
	coupon: {
		title: "我的優惠券",
		unused: "未使用",
		used: "已使用",
		expired: "已過期",
		empty: "暫無內容",
		minimum: "滿{amount}可用",
		validUntil: "有效期至{date}",
		usageRules: "使用規則",
		ruleTip: "每張優惠券僅能使用一次，不可與其他優惠疊加使用，部分商品不適用，詳情請查看使用說明。",
	},
	follow: {
		title: "我的追蹤",
		creatorCount: "追蹤的創作者 {count}",
		likes: "獲讚",
		followers: "追蹤者",
		shareCreator: "分享{name}",
		viewMore: "查看更多",
		viewsTenThousand: "{count} 萬次觀看",
		viewsCount: "{count} 次觀看",
		empty: "暫無追蹤內容",
		latest: "最新更新",
		recentFollowed: "最近追蹤",
		demoVideoTitle:
			"霸道總裁愛上我? 老少配最幸福? 從八字「天干五合看穩定婚姻模式! 乙庚合是大佬配置?",
		demoViews: "12586觀看",
		demoDate: "2天前",
		demoCreatorName: "趙振鴻",
		demoCategory: "情感關係 · 命理解讀",
		demoDescription: "是一位非常厲害的人物~",
	},
	message: {
		title: "我的消息",
		clearUnread: "清除未讀",
		notifyTitle: "開啟通知不錯過任何重要訊息!",
		notifyDesc: "開啟瀏覽器通知，立即接收最新消息與優惠提醒",
		enableNotify: "開啟通知",
		teacherMessages: "導師消息",
		systemMessages: "系統消息",
		inService: "服務中...",
		enterChat: "進入聊天",
		demoChatDate: "12月24日  09:26",
		demoTeacherBubble: "你是這樣的嗎我還是那樣的",
		demoTeacherIntro1: "導師介紹文案內容導師介紹文案內",
		demoTeacherIntro2: "容導師介紹文案內容",
		demoUserBubble: "導師，我不知道他還對我有沒有意思，能幫我看一下嗎？",
		demoLinkPrefix: "這是一個連結問答：",
		demoServiceTip: "導師為你推薦一個服務：",
		demoServiceTitle: "一生事業批算",
		demoServiceDesc:
			"每個人的一生都希望自己有所成就，不論從事哪種行業，只要充分發揮你的優勢，再加上後天努力，每一行都可以成功。導師會透過你的生日密碼，為你…",
		demoOriginPrice: "原價 2688銅幣",
		orderNow: "立即下單",
		demoOrderNotice: "“2026財運分析”高級服務下單成功，感謝您對平台的信任與支持",
		demoAgreementPrefix: "您需閱讀",
		demoAgreementLinks: "《用戶協議》《隱私協議》《平台服務須知》",
		demoAgreementSuffix: "，如果繼續諮詢代表您以知悉相關規定與風險並同意相關條款",
		demoRiskNotice: "嚴禁一切淫穢、攻擊、違法言論，若發現請前往個人中心-幫助中心-人工客服進行舉報",
		demoAddressNotice: "當前服務包含商品，為了方便寄發商品，請前往填寫收貨地址。",
		fillAddress: "填寫個人地址>>",
		inputPlaceholder: "你好導師，我想諮詢婚姻危機的問題",
		send: "發送",
		demoTeacherSubtitle: "八字命理 風水擇吉",
	},
	order: {
		title: "我的訂單",
		searchPlaceholder: "請輸入訂單號/電郵/手機號",
		search: "查詢訂單",
		count: "共{count}筆訂單",
		goTo: "前往",
		page: "頁",
		notFoundTitle: "找不到訂單？",
		reasonPrefix: "可能是以下原因：",
		reasonAccount: "· 使用了不同的電郵或賬號",
		reasonUnpaid: "· 訂單未成功支付",
		reasonCanceled: "· 訂單已被取消或逾期",
		allOrders: "全部訂單",
		paidTest: "付費測算",
		teacherConsult: "導師諮詢",
		voiceConsult: "語音諮詢",
		mallOrder: "吉品訂單",
		institutionOrder: "機構訂單",
		otherOrder: "其他訂單",
		status: "訂單狀態",
		amount: "訂單金額",
		mallStatusPaid: "支付成功",
		mallStatusRefunded: "已退款",
		statusFilterAll: "全部",
		statusFilterPaid: "已付費",
		statusFilterUnpaid: "待支付",
		statusFilterCancelled: "已取消/退款",
	},
	profile: {
		title: "我的個人資料",
		name: "姓名",
		namePlaceholder: "請輸入姓名",
		gender: "性別",
		birthDate: "出生日期",
		birthDatePlaceholder: "請選擇出生日期",
		birthArea: "出生地區",
		birthAreaPlaceholder: "請選擇出生地區",
		livingArea: "居住地區",
		livingAreaPlaceholder: "請選擇居住地區",
		email: "電郵賬號",
		emailPlaceholder: "請輸入電郵賬號",
		phone: "手機號碼",
		phonePlaceholder: "請輸入手機號碼",
		goLink: "去綁定",
		changeEmail: "更換電郵",
		changePhone: "更換手機號",
		saveUnsupported: "保存接口待對接，請提供 YApi 文檔後接入",
		saveSuccess: "保存成功",
		saveFailed: "保存失敗，請重試",
		avatarUploadFailed: "頭像上傳失敗",
	},
	sidebar: {
		wallet: "我的錢包",
		needHelp: "需要幫助？",
		helpDesc: "如有任何問題，請聯繫客服中心",
		monthlyMember: "月費會員",
		normalMember: "普通會員",
		goodMorning: "早上好呀~",
		goodNoon: "中午好呀~",
		goodAfternoon: "下午好呀~",
		goodEvening: "晚上好呀~",
		goodNight: "淩晨了，註意休息喔~",
		coupon: "優惠券",
		address: "地址管理",
		profile: "個人資料",
		account: "賬號資料",
		logout: "登出賬戶",
	},
	logout: {
		title: "您確認要退出登錄先知命局嗎？",
		confirmButton: "退出登錄",
	},
	wallet: {
		totalAssets: "我的總資產",
		rechargeRecords: "儲值明細",
		rechargeAmount: "儲值金額",
		givingAmount: "贈送金額",
		selectAmount: "選擇儲值金額",
		amountRate: "（1點數=1美元）",
		confirmRecharge: "確認儲值",
		pointsBadge: "+{amount}點數",
		agreementPrefix: "我已閱讀並同意",
		agreementLink: "《服務協議》",
		recordsEmpty: "暫無內容",
		tabGiving: "贈送記錄",
		tabRecharge: "儲值記錄",
		tabConsume: "消費記錄",
		givingTag: "贈送",
		validUntil: "有效期：",
		date: "{year}年{month}月{day}日",
		dateTime: "{year}年{month}月{day}日 {hour}:{minute}",
		expired: "已過期",
		expiringSoon: "即將過期",
		rechargeSuccess: "儲值成功",
		checkout: "收銀台",
		selectCurrency: "請選擇貨幣類型",
		selectPayment: "請選擇支付方式",
		more: "更多",
		collapse: "收起",
		balance: "餘額:",
		payNow: "立即支付",
		paymentConfirmTitle: "是否已完成支付？",
		paymentCompleted: "已完成",
		rechargeSuccessMessage: "儲值成功",
		agreementRequired: "請先閱讀並同意協議",
		paymentSuccess: "支付成功",
		paymentNotFound: "未能查到支付信息，請稍後重試",
		balanceInsufficient: "餘額不足",
		paymentProcessing: "支付中",
		jumpPayFailed: "跳轉支付頁面失敗，請重試",
		checkPayFailed: "查詢支付狀態失敗，請稍後重試",
		selectPayArea: "支付地區",
		noCoupon: "暫無優惠劵可用",
		discountedPrice: "到手價",
		originalPriceCoin: "原價{amount}點數",
		payAreas: {
			china: "中國",
			hongKongMacau: "香港/澳門",
			malaysia: "馬來西亞",
			singapore: "新加坡",
			globalOtherUnknown: "全球其他/未知",
			taiwan: "台灣",
			indonesia: "印尼",
			vietnam: "越南",
			thailand: "泰國",
		},
		payMethods: {
			wechatPay: "微信支付",
			stripe: "Stripe",
			paypal: "PayPal",
			alipay: "支付寶",
			newebPay: "藍新支付（超商、條碼等等）",
			tngWallet: "TNG電子錢包",
			publicBank: "Public銀行",
			maybank: "Maybank銀行",
			ocbcBank: "Ocbc銀行",
			myCard: "MyCard",
			linePay: "LinePay",
			points: "點數",
			creditCard: "信用卡",
			globalCreditCard: "全球信用卡支付",
			macauCreditCard: "澳門信用卡",
			taiwanLinePay: "台灣LinePay支付",
		},
	},
	benefits: {
		title: "APP專屬福利",
		downloadTitle: "準備開始探索人生方向？",
		downloadDesc: "立即下載先知命局App，開啟屬於你的智慧之旅",
		downloadApk: "Download APK",
		downloadOnThe: "Download on the",
		googlePlay: "Google Play",
		appStore: "App Store",
		androidApk: "Android APK",
		beanLine1: "集福豆",
		beanLine2: "兌大獎",
		vipLine1: "免費體驗",
		vipLine2: "會員服務",
		blessingLine1: "祈福台",
		blessingLine2: "每日祈福",
		liveLine1: "導師直播Oncall",
		liveLine2: "免費3分鐘",
		meditationLine1: "冥想空間",
		meditationLine2: "日常療癒",
	},
	address: {
		title: "地址管理",
		addAddress: "新增地址",
		empty: "暫無地址",
		formTitle: "新增/編輯地址",
		recipientName: "收貨人姓名",
		recipientNamePlaceholder: "請輸入收貨人姓名",
		recipientNameRequired: "請輸入收貨人姓名",
		recipientNameMax: "收貨人姓名不能超過20字",
		contactPhone: "聯絡電話",
		contactPhonePlaceholder: "請輸入聯絡電話",
		contactPhoneRequired: "請輸入聯絡電話",
		areaCodePlaceholder: "區號",
		areaCodeRequired: "請選擇區號",
		contactEmail: "聯繫電郵",
		contactEmailPlaceholder: "請輸入聯繫電郵",
		contactEmailRequired: "請輸入聯繫電郵",
		postalCode: "郵政編碼",
		postalCodePlaceholder: "請輸入郵政編碼",
		postalCodeHint: "例:110",
		postalCodeRequired: "請輸入郵政編碼",
		countryRegion: "國家/地區",
		countryRegionPlaceholder: "請選擇國家/地區",
		countryRegionRequired: "請選擇國家/地區",
		detailAddress: "詳細地址",
		detailAddressPlaceholder: "請輸入詳細地址",
		detailAddressRequired: "請輸入詳細地址",
		setDefault: "設置為預設地址",
		defaultAddress: "預設地址",
		copy: "複製",
		modify: "修改",
		deleteConfirm: "確認刪除該地址嗎？",
		deleteUnsupported: "暫不支持刪除地址",
	},
};
